export default __webpack_public_path__ + "static/media/br.e3cf9c2b.png";